type MessageHandler = (event: MessageEvent) => void

class MercureHub {
    private urlToSource: Map<string, EventSource> = new Map()
    private urlToHandlers: Map<string, Set<MessageHandler>> = new Map()

    subscribe(url: string, handler: MessageHandler) {
        const handlers = this.urlToHandlers.get(url) ?? new Set<MessageHandler>()
        handlers.add(handler)

        this.urlToHandlers.set(url, handlers)

        if (!this.urlToSource.has(url)) {
            const source = new EventSource(url, { withCredentials: true })
            source.onmessage = (event) => {
                const handlerSet = this.urlToHandlers.get(url)

                if (!handlerSet || handlerSet.size === 0) {
                    return
                }

                handlerSet.forEach((handler) => handler(event))
            }

            this.urlToSource.set(url, source)
        }
    }

    unsubscribe(url: string, handler: MessageHandler) {
        const handlers = this.urlToHandlers.get(url)

        if (!handlers) {
            return
        }

        handlers.delete(handler)

        if (handlers.size === 0) {
            this.urlToHandlers.delete(url)
            const source = this.urlToSource.get(url)

            if (source) {
                source.close()
                this.urlToSource.delete(url)
            }
        }
    }
}

const hub = new MercureHub()

export const mercureSubscribe = (url: string, handler: MessageHandler) => hub.subscribe(url, handler)
export const mercureUnsubscribe = (url: string, handler: MessageHandler) => hub.unsubscribe(url, handler)
